import React, { useMemo } from 'react';
import { Table, Form, Row, Col, Card } from 'react-bootstrap';

const MappingTable = ({ mappingConfig, onMapChange, sourceDataPreview }) => {

    // This is the core logic that transforms the raw data based on the current mapping
    const mappedDataPreview = useMemo(() => {
        const mapped = {};
        const tempAddressParts = [];

        for (const sourceKey in mappingConfig.currentMap) {
            const targetKey = mappingConfig.currentMap[sourceKey];
            if (targetKey !== '(Unmapped)' && sourceDataPreview[sourceKey] !== undefined) {
                // Special logic for combining fields
                if (targetKey === 'fullName') {
                    mapped.fullName = `${sourceDataPreview.CUST_FNAME || ''} ${sourceDataPreview.CUST_LNAME || ''}`.trim();
                } else if (targetKey === 'address') {
                    // Collect all parts mapped to 'address'
                    tempAddressParts.push(sourceDataPreview[sourceKey]);
                } else {
                    mapped[targetKey] = sourceDataPreview[sourceKey];
                }
            }
        }

        // After the loop, combine the address parts
        if (tempAddressParts.length > 0) {
            mapped.address = tempAddressParts.join(', ');
        }

        return mapped;
    }, [mappingConfig.currentMap, sourceDataPreview]);

    return (
        <div>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Source System Field (CBS)</th>
                        <th>Maps To</th>
                        <th>Target System Field (AML)</th>
                    </tr>
                </thead>
                <tbody>
                    {mappingConfig.sourceFields.map(sourceField => (
                        <tr key={sourceField}>
                            <td><code>{sourceField}</code></td>
                            <td style={{ width: '250px' }}>
                                <Form.Select
                                    value={mappingConfig.currentMap[sourceField] || '(Unmapped)'}
                                    onChange={(e) => onMapChange(sourceField, e.target.value)}
                                >
                                    {mappingConfig.targetFields.map(targetField => (
                                        <option key={targetField} value={targetField}>{targetField}</option>
                                    ))}
                                </Form.Select>
                            </td>
                            <td>
                                <span className="text-success">{mappingConfig.currentMap[sourceField] || ''}</span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <h4 className="mt-4">Live Mapping Preview</h4>
            <Row>
                <Col md={6}>
                    <Card>
                        <Card.Header>Source Data (Raw)</Card.Header>
                        <Card.Body>
                            <pre><code>{JSON.stringify(sourceDataPreview, null, 2)}</code></pre>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card>
                        <Card.Header>Mapped Data (Result)</Card.Header>
                        <Card.Body className="bg-light">
                            <pre><code>{JSON.stringify(mappedDataPreview, null, 2)}</code></pre>
                        </Card.Body>
                        <Card.Footer className="text-muted">
                            This is the clean, standardized object the AML Rule Engine will receive.
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default MappingTable;